import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import "./School.css";
import { shareConstants } from "../utils/shareConstants";
import {transferListLanguageOptions} from "./dropdown/dropdown-data";

const SharePurchase = () => {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accountList, setAccountList] = useState([]);

  const [confirmMessage, setConfirmMessage] = useState("notLoaded");
  const [successMessage, setSuccessMessage] = useState("notLoaded");
  const [jwt, setJwt] = useState(0);
  const [userName, setUserName] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [title, setTitle] = useState();
  const [warning] = useState("");
  const [onConfirm, setOnConfirm] = useState("");
  const [transferRequest, setTransferRequest] = useState("");
  const [, setExtractedUrl] = useState("");
  const [selectedPeriods, setSelectedPeriods] = useState([]);
  const [, setCalculatedPayment] = useState(null);
  const [, setChecked] = useState(false);
  const [shareCount, setShareCount] = useState(15);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [pricePerShare] = useState(1000);
  const [minor, setMinor] = useState(true);
  const [fileNumber, setFileNumber] = useState("");

  const [searchBy, setSearchBy] = useState("self");
  const [holderType, setHolderType] = useState("NEW");

  const [fullName, setFullName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [nId, setNId] = useState("");
  const [phone, setPhone] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [, setResult] = useState(null);
  const [error, setError] = useState(null);

  const [selectedFee, setSelectedFee] = useState("");
  const [, setFeeDetail] = useState(null);
  const [, setCheckedItems] = useState([]);

  const [isFirst, setIsFirst] = useState(true);
  const totalPrice = shareCount * pricePerShare;
  const feePrice =  (totalPrice * 5) / 100 ;
  const finalPrice = totalPrice + feePrice;

  const getAccountListFromAndroid = (obj, objData) => {
    if (JSON.parse(obj.request).name === "accountList") {
      if (
          obj.response !== undefined &&
          JSON.parse(obj.response).data !== undefined
      ) {
        let uniqueAccountList = [];
        JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
          uniqueAccountList = [
            ...uniqueAccountList,
            { label: account.accounts, value: account.accounts },
          ];
          setAccountList([...uniqueAccountList]);
        });
      }
    }
  };

  const isFormValid = () => {
    if (!selectedAccount) return false;
    if (!agreeToTerms) return false;
    if (holderType==="NEW" && shareCount < 15) return false;
    if (holderType==="EXISTING" && shareCount < 1) return false;
    return true;
  };
  const handleShareCountChange = (e) => {
    const value = e.target.value;
    // Allow empty string or numbers
    if (value === "" || /^[0-9]*$/.test(value)) {
      setShareCount(value);
      // Clear error when typing
      if (error) setError("");
    }
  };

  const handleConfirm = () => {
    setIsOpen(false);
    handleBuyShares();
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleBuyShares = () => {
    const numValue = parseInt(shareCount, 10);
    if (isNaN(numValue)){
    setError("Share amount cannot be empty!");
  return;
}
    else if (numValue < 15) {
      setError("Minimum 15 shares required");
      return;
    }else{
      const message =
          `<b>Share payment request for : </b> ${fullName} <br><br>` +
          `<b>Share Amount: </b> ${totalPrice} Service charge: ${feePrice} <br><br>` +
          `<b>Total amount </b> ${finalPrice} click confirm to complete purchase request <br><br>`;

      if (searchBy === "self") {
        setTransferRequest({
          fullName:userName,
          oldFileNumber: fileNumber,
          feeAmount: feePrice,
          shareAmount: totalPrice,
          totalAmount: finalPrice,
          quantity: shareCount,
          accountNumber: selectedAccount,
          phoneNumber: phone,
          shareHolderType: holderType,
          hashedValue: "hashedValue",
        });
      }else{
        setTransferRequest({
          motherName:motherName,
          minor:minor,
          fullName:fullName,
          feeAmount: feePrice,
          shareAmount: totalPrice,
          totalAmount: finalPrice,
          quantity: shareCount,
          accountNumber: selectedAccount,
          phoneNumber: phone,
          shareHolderType: holderType,
          requestedBy:userName,
          hashedValue: "hashedValue",
        });
      }
      setConfirmMessage(message);
    }

  };

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };



  const getDataFromAndroid = () => {
    window.receiveDataFromAndroid = (data) => {
      const dataString = JSON.stringify(data);
      const obj = JSON.parse(dataString);
      const objName = JSON.parse(obj.request).name;
      const objData = JSON.parse(obj.response).data;
      const urlFromResponse = JSON.parse(obj.request).url;

      switch (objName) {
        case "accountList":
          getAccountListFromAndroid(obj, objData);
          break;
        case "confirmResponse":
          setOnConfirm("true");
          break;
        case "jwt":
          setJwt(objData);
          break;
        case "response":
          setExtractedUrl(urlFromResponse);
          handleDataBasedOnUrl(urlFromResponse, objData);
          break;
        case "userName":
          setUserName(objData);
          break;
        default:
          break;
      }
    };
  };



  const handleDataBasedOnUrl = (url, responseData) => {
    console.log("method called " + url);
   if (url.includes("shareApp/services/selfRegistration")
        || url.includes("shareApp/services/otherRegistration")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setSuccessMessage(
            `Share purchase of amount ${data.payload.amount} is successful with service charge ${data.payload.fee} and transaction reference number ${data.payload.transactionId} Please proceed to upload necessary documents with the link sent in the confirmation SMS.`
        );
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("pnr")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setFeeDetail(data.payload);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    }
  };




  const handleAccountChange = (e) => {
    setSelectedAccount(e.target.value);
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
  };


  const handleFullNameChange = (e) => {
    setFullName(e.target.value.toUpperCase());
  };
  const handleFileNumber = (e) => {
    setFileNumber(e.target.value.toUpperCase());
  };

  const handleMotherNameChange = (e) => {
    setMotherName(e.target.value.toUpperCase());
  };
  const handleNationalIdChange = (e) => {
    setNId(e.target.value.toUpperCase());
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value.toUpperCase());
  };



  useEffect(() => {
    if (selectedFee) {
      setFeeDetail(null);
      setSelectedPeriods([]);
      setCalculatedPayment(null);
      setCheckedItems([]);
      setChecked(false);
    }
  }, [selectedFee]);

  useEffect(() => {
    if (selectedPeriods) {
      setCalculatedPayment(null);
    }
  }, [selectedPeriods]);

  useEffect(() => {
    if (!isFirst) {
      setTitle(transferListLanguageOptions[jwt][8]);
    }
    setIsFirst(false);
  }, [jwt]);
  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  useEffect(() => {
    handleFirstRender("confirm");
  }, [confirmMessage]);
  useEffect(() => {
    handleFirstRender("success");
  }, [successMessage]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [errorMessage]);

  useEffect(() => {
    handleFirstRender("openLoading");
  }, [loading]);

  useEffect(() => {
    handleFirstRender("openLoading");
    if (closeLoading) {
      setLoading(false);
      setCloseLoading(false);
    }
  }, [closeLoading]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [warning]);

  useEffect(() => {
    if (onConfirm !== "") {
      handleFirstRender("request");
    }
  }, [onConfirm]);


  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "confirm") {
      transferData = {
        transferData: [
          {
            type: "confirm",
            request: { name: "confirm" },
            response: { data: confirmMessage },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: loading },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: closeLoading },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "success") {
      transferData = {
        transferData: [
          {
            type: "success",
            request: { name: "success" },
            response: { data: successMessage },
            name: "",
          },
        ],
      };
    }else if (name === "request") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: searchBy === "self" ? "shareApp/services/selfRegistration": "shareApp/services/otherRegistration",
            },
            response: {
              data:
                JSON.stringify(transferRequest)
            },
            name: "",
          },
        ],
      };
    }
    sendToAndroid(transferData);
    setConfirmMessage("");
    setOnConfirm("");
    setErrorMessage("");
  };

  useEffect(() => {
    console.log("First Render");
    if (isFirst) {
      sendDataToAndroid("first");
    }
    getDataFromAndroid();
  }, [getDataFromAndroid, sendDataToAndroid]);

  return (
    <div className="service-screen w-full max-w-md mx-auto p-4">
      <div className="border border-gray-300 rounded-xl shadow-lg p-6 bg-white">
        <div className="mb-4">
          <label className="block mb-1 font-medium text-gray-700">
            {shareConstants[jwt]?.labels[0]}
          </label>
          <select
            value={selectedAccount}
            onChange={handleAccountChange}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option key={0} value={"choose"}>
              {shareConstants[jwt]?.labels[0]}
            </option>
            {accountList.map((s) => (
              <option key={s.id} value={s.value}>
                {s.value}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <div className="flex gap-4">
            <label className="flex items-center gap-2 text-gray-600">
              <input
                type="radio"
                name="searchBy"
                value="self"
                checked={searchBy === "self"}
                onChange={() => {
                  setSearchBy("self");
                }}
              />
              {shareConstants[jwt]?.labels[2]}
            </label>
            <label className="flex items-center gap-2 text-gray-600">
              <input
                type="radio"
                name="searchBy"
                value="other"
                checked={searchBy === "other"}
                onChange={() => {
                  setSearchBy("other");
                  setHolderType("NEW")
                }}
              />
              {shareConstants[jwt]?.labels[1]}
            </label>
          </div>
        </div>
        {searchBy === "self" ? (
          <>
            <label className="block mb-1 font-medium text-gray-700">
              {shareConstants[jwt]?.labels[17]}
            </label>
            <div className="mb-4">
              <div className="flex gap-4">
                <label className="flex items-center gap-2 text-gray-600">
                  <input
                      type="radio"
                      name="holderType"
                      value="NEW"
                      checked={holderType === "NEW"}
                      onChange={() => {
                        setHolderType("NEW");

                      }}
                  />
                  {shareConstants[jwt]?.labels[18]}
                </label>
                <label className="flex items-center gap-2 text-gray-600">
                  <input
                      type="radio"
                      name="holderType"
                      value="EXISTING"
                      checked={holderType === "EXISTING"}
                      onChange={() => {
                        setHolderType("EXISTING");
                      }}
                  />
                  {shareConstants[jwt]?.labels[19]}
                </label>
              </div>
            </div>
            <>
            {holderType === "EXISTING" ? (
                <>
                <div className="mb-4">
                  <label className="block mb-1 font-medium text-gray-700">
                    {shareConstants[jwt]?.labels[20]}
                  </label>
                  <input
                      type="number"
                      value={fileNumber}
                      onChange={handleFileNumber}
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      placeholder="file number"
                  />
                </div>
                  </>
            ): null}
            </>
          </>
        ) : (
          <>
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700">
                {shareConstants[jwt]?.labels[10]}
              </label>
              <input
                type="text"
                value={fullName}
                onChange={handleFullNameChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Full Name"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700">
                {shareConstants[jwt]?.labels[11]}
              </label>
              <input
                type="text"
                value={motherName}
                onChange={handleMotherNameChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Mother name"
              />
            </div>
            <div className="mb-4">
              <label className="block mb-1 font-medium text-gray-700">
                {shareConstants[jwt]?.labels[12]}
              </label>
              <input
                type="text"
                value={nId}
                onChange={handleNationalIdChange}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="National Id number"
              />
            </div>
            <div className="mb-4">
              <label className="flex items-center gap-2 text-gray-600">
                <input
                    type="radio"
                    name="minor"
                    checked={minor === false}
                    onChange={() => setMinor(false)}
                />
                {shareConstants[jwt]?.labels[16]}
              </label>

              <div className="flex gap-4">
                <label className="flex items-center gap-2 text-gray-600">
                  <input
                      type="radio"
                      name="minor"
                      checked={minor === true}
                      onChange={() => setMinor(true)}
                  />
                  {shareConstants[jwt]?.labels[15]}
                </label>
              </div>
            </div>
          </>
        )}
        <div className="mb-4">
          <label className="block mb-1 font-medium text-gray-700">
            {shareConstants[jwt]?.labels[13]}
          </label>
          <input
              type="number"
              value={phone}
              onChange={handlePhoneChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="phone number"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 font-medium text-gray-700">
            {shareConstants[jwt]?.labels[3]}
          </label>
          <input
              type="text"
              value={shareCount}
              onChange={handleShareCountChange}
              className={`w-full border ${
                  error ? "border-red-500" : "border-gray-300"
              } rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400`}
          />
          {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>

        <div className="mb-4">
          <label className="block mb-1 font-medium text-gray-700">
            {shareConstants[jwt]?.labels[4]}
          </label>
          <div className="p-2 bg-gray-100 rounded">
            {pricePerShare.toLocaleString()} {"Birr"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 text-center mb-2">
          <div className="p-2 border rounded">
            <div className="text-m text-gray-500 mb-1">
              {shareConstants[jwt]?.labels[5]}
            </div>
            <div className="font-medium">
              {totalPrice.toLocaleString()} Birr
            </div>
          </div>

          <div className="p-2 border rounded">
            <div className="text-m text-gray-500 mb-1">
              {shareConstants[jwt]?.labels[6]}
            </div>
            <div className="font-medium">
              {feePrice.toLocaleString()} Birr
            </div>
          </div>
        </div>
        <div className="p-2 border rounded bg-blue-50 mb-2">
          <div className="text-m font-medium text-gray-600 mb-1">
            {shareConstants[jwt]?.labels[7]}
          </div>
          <div className="font-bold text-xl">
            {finalPrice.toLocaleString()} Birr
          </div>
        </div>

        <div className="mb-4 flex items-center">
          <input
              type="checkbox"
              id="agreeTerms"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              className="mr-2"
          />
          <label htmlFor="agreeTerms" className="text-sm text-blue-800">
            {shareConstants[jwt]?.labels[8]}{" "}
            <a
                href="https://apps.hijradigital.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
            >
              (View Terms and conditions here)
            </a>
          </label>
        </div>

        <button
            onClick={() => setIsOpen(true)}
            disabled={!isFormValid()}
            className={`w-full py-2 rounded text-white font-semibold transition ${
                isFormValid()
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
            }`}
        >
          {shareConstants[jwt]?.labels[9]}
        </button>
        {isOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
                <h2 className="text-lg font-semibold mb-4">{shareConstants[jwt]?.labels[23]}</h2>
                <div className="mb-6 text-gray-600 space-y-4">
                  <p>
                    <strong>{shareConstants[jwt]?.labels[24]}:</strong> {searchBy==="self" ? userName : fullName}
                  </p>
                  <p>
                    <strong>{shareConstants[jwt]?.labels[25]}:</strong> {totalPrice} <br />
                    <strong>{shareConstants[jwt]?.labels[26]}:</strong> {feePrice}
                  </p>
                  <p>
                    <strong>{shareConstants[jwt]?.labels[27]}:</strong> {finalPrice} <br />
                    {shareConstants[jwt]?.labels[28]}
                  </p>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                      onClick={handleCancel}
                      className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                  >
                    {shareConstants[jwt]?.labels[29]}
                  </button>
                  <button
                      onClick={handleConfirm}
                      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                  >
                    {shareConstants[jwt]?.labels[30]}
                  </button>
                </div>
              </div>
            </div>
        )}

      </div>
    </div>
  );
};

export default SharePurchase;
